export default __webpack_public_path__ + "static/media/image-postular.5cb8eb5a.png";